module.exports = __webpack_public_path__ + "static/media/edit-active-ic.0f1cf112.svg";